// @flow

import {type RecordFactory, type RecordInstance, Record} from 'immutable';

import {
  setNormalizedList,
  getRequestResponseMapFactory,
  type RequestResponseMapType,
} from 'app/utils/redux_v2';

import {
  RECEIVE_SIGNOFFTEMPLATE_LIST,
  RECEIVE_SIGNOFF_LIST,
  RECEIVE_DOCUMENT_SIGNOFF_LIST,
  RECEIVE_GROUPEDSIGNOFF_LIST,
  type SignoffActions,
} from './actions';
import type {
  SignoffTemplateType,
  SignoffType,
  DocumentSignoffType,
  GroupedSignoffType,
} from './types';

type StateShape = {
  signofftemplates: RecordInstance<RequestResponseMapType<SignoffTemplateType>>,
  signoffs: RecordInstance<RequestResponseMapType<SignoffType>>,
  documentsignoffs: RecordInstance<RequestResponseMapType<DocumentSignoffType>>,
  groupedSignoffs: RecordInstance<RequestResponseMapType<GroupedSignoffType>>,
};

const StateFactory: RecordFactory<StateShape> = Record({
  signofftemplates: getRequestResponseMapFactory<SignoffTemplateType>(),
  signoffs: getRequestResponseMapFactory<SignoffType>(),
  groupedSignoffs: getRequestResponseMapFactory<GroupedSignoffType>(),
  documentsignoffs: getRequestResponseMapFactory<DocumentSignoffType>(),
});

export type RecordOfSignoffsState = RecordInstance<StateShape>;

export const signoffs = (
  state: RecordOfSignoffsState = StateFactory(),
  action: SignoffActions
): RecordOfSignoffsState => {
  switch (action.type) {
    case RECEIVE_SIGNOFF_LIST:
      return state.set(
        'signoffs',
        setNormalizedList(action.query, action.response, state.get('signoffs'))
      );

    case RECEIVE_DOCUMENT_SIGNOFF_LIST:
      return state.set(
        'documentsignoffs',
        setNormalizedList(
          action.query,
          action.response,
          state.get('documentsignoffs'),
          (doc) => `${doc.user_id}:${doc.document_id}`
        )
      );

    case RECEIVE_SIGNOFFTEMPLATE_LIST:
      return state.set(
        'signofftemplates',
        setNormalizedList(
          action.query,
          action.response,
          state.get('signofftemplates')
        )
      );

    case RECEIVE_GROUPEDSIGNOFF_LIST:
      return state.set(
        'groupedSignoffs',
        setNormalizedList(
          action.query,
          action.response,
          state.get('groupedSignoffs')
        )
      );

    default:
      return state;
  }
};
